var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{attrs:{"color":_vm.color,"flat":_vm.flat}}),_c('v-main',{staticClass:"pt-0"},[_c('Inicio'),_c('Gifs'),_c('Formatos'),_c('Testimonios'),_c('Bonos',{attrs:{"bonos":[
        'Plantillas optimizadas para tu taller',
        'Actualizaciones menores sin costo adicional',
        'Entrega del formato digital en menos de 72 horas',
        'Acceso exclusivo a tutoriales en video',
        'Soporte técnico prioritario vía WhatsApp',
        'Integración con software de facturación (opcional)',
        'Capacitación gratuita para el equipo de trabajo',
        'Personalización del formato con el logo de tu taller',
      ]}}),_c('Faq',{attrs:{"preguntas":[
        {
          pregunta:
            '¿Cómo recibo el formato de la Orden de Servicio Digital?',
          respuesta:
            'Recibirás un enlace único con las credenciales de acceso.',
        },
        {
          pregunta: '¿Necesito instalar algún programa?',
          respuesta:
            'No, el sistema es completamente en línea y accesible desde cualquier dispositivo con internet.',
        },
        {
          pregunta: '¿Qué pasa si necesito soporte técnico?',
          respuesta: 'Ofrecemos soporte vía WhatsApp',
        },
        {
          pregunta: '¿Puedo personalizar el formato con mi logo?',
          respuesta:
            'Sí, puedes agregar el logo de tu taller y ajustar algunos campos.',
        },
        {
          pregunta: '¿Cuánto tiempo tarda la entrega del formato?',
          respuesta:
            'Tu formato estará listo en menos de 72 horas después de la compra.',
        },
        {
          pregunta: '¿Las actualizaciones tienen costo?',
          respuesta:
            'Las actualizaciones menores son gratuitas; si hay mejoras grandes, ofrecemos descuentos exclusivos a clientes.',
        },
        {
          pregunta: '¿Puedo solicitar modificaciones especiales?',
          respuesta:
            'Sí, podemos adaptar el formato a tus necesidades con un costo adicional.',
        },
        {
          pregunta: '¿Qué métodos de pago aceptan?',
          respuesta:
            'Aceptamos transferencias bancarias y pagos en efectivo.',
        },
      ]}}),_c('Contacto')],1),_c('v-scale-transition',[_c('v-btn',{staticClass:"timer-btn",attrs:{"fab":"","dark":"","fixed":"","bottom":"","right":"","color":"red"},on:{"click":function($event){return _vm.$vuetify.goTo('#benefits')}}},[_c('span',{staticClass:"timer-text"},[_vm._v(_vm._s(_vm.remainingTime.minutes)+":"+_vm._s(_vm.remainingTime.seconds))])])],1),_c('v-scale-transition',[_c('div',{staticClass:"offer-btn"},[_c('span',{staticClass:"offer-text"},[_vm._v("¡Aprovecha la oferta!")])])]),_c('v-scale-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"}],staticClass:"mt-12",attrs:{"fab":"","dark":"","fixed":"","bottom":"","right":"","color":"secondary","href":'https://wa.me/5214434846542',"target":"_blank"}},[_c('v-icon',[_vm._v("mdi-whatsapp")])],1)],1),_c('v-scale-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"},{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"fab":"","dark":"","fixed":"","bottom":"","left":"","color":"secondary"},on:{"click":_vm.toTop}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }